import * as React from 'react';
import { connect } from 'react-redux';

import Page from 'components/page/Page';
import BrandProfile from '../components/BrandProfile';

import { t } from 'utils/language';

import type { BrandProfile as BrandProfileType, Params } from 'types';

type OwnProps = {
  params: Params
};

type StateProps = {
  profile: BrandProfileType
};

type Props = OwnProps & StateProps;

const BrandViewProfilePage = (
  {
    params,
    profile
  }: Props
): JSX.Element => (
  <Page
    documentTitle={`
      ${t('brand_profile_title', { brandName: profile.name })}
    `}
  >
    <BrandProfile
      key={params.id}
      profileId={Number(params.id)}
    />
  </Page>
);

const mapStateToProps = ({ brandProfile }): StateProps => ({
  profile: brandProfile.profile
});

export default connect(mapStateToProps)(BrandViewProfilePage);
